<div *ngIf="chart">
    <h3>{{data.eventName}}</h3>
    <canvas #canvas>{{ chart }}</canvas>
</div>
